export default "__VITE_ASSET__DCoqWH2E__"